"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeCompanyDTO = void 0;
const E = __importStar(require("fp-ts/Either"));
const function_1 = require("fp-ts/function");
const t = __importStar(require("io-ts"));
const io_ts_types_1 = require("io-ts-types");
const validation_1 = require("@bloodline-packages/bloodline/dist/validation");
const codecs_1 = require("../codecs");
const CompanyC = t.type({
    companyName: (0, io_ts_types_1.optionFromNullable)(t.string),
    orgnr: codecs_1.OrgnrCodec,
    operationalStatus: (0, io_ts_types_1.optionFromNullable)(t.string),
    domain: (0, io_ts_types_1.optionFromNullable)(t.string),
    email: (0, io_ts_types_1.optionFromNullable)(t.string),
    phone: (0, io_ts_types_1.optionFromNullable)(t.string),
    pipedriveOrganizationIds: t.array(t.number),
    numberOfEmployees: (0, io_ts_types_1.optionFromNullable)(t.number),
    numberOfEmployeesSource: (0, io_ts_types_1.optionFromNullable)(t.string),
});
exports.decodeCompanyDTO = (0, function_1.flow)(CompanyC.decode, E.mapLeft((0, validation_1.toValidationError)("Couldn't decode CompanyDTO")));
const CompanyEquals = true;
const CompanyDTOEquals = true;
//# sourceMappingURL=company.js.map